import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditProfile from "../../components/User/EditProfile";

export default withRouter(connect()(EditProfile));
